import type {AfriexCurrency} from '@/types';

type SummaryProp = {
  item: AfriexCurrency;
};

const Summary = ({item}: SummaryProp) => {
  return (
    <div className="flex flex-col gap-3 mt-4">
      <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-200">
        {item?.name} Details
      </h3>
      <div className="overflow-x-auto">
        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 justify-between">
          <p className="text-slate-500 text-sm dark:text-slate-100">Name</p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100 dark:bg-gray-900">
            {item?.name}
          </p>
        </div>
        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
          <p className="text-slate-500 text-sm dark:text-slate-100">Code</p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {item?.code}
          </p>
        </div>
        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
          <p className="text-slate-500 text-sm dark:text-slate-100">Symbol</p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {item?.symbol || 'Not Set'}
          </p>
        </div>
        <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 justify-between dark:bg-gray-900">
          <p className="text-slate-500 text-sm dark:text-slate-100">Status</p>
          <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
            {item?.isActive ? 'Active' : 'Inactive'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Summary;
